var map = {
	"./PIN_TEST.png": 972,
	"./PIN_TEST2.png": 973,
	"./asd2.png": 974,
	"./atm.svg": 975,
	"./atm_pin.png": 976,
	"./cubano_logo.png": 977,
	"./cubano_pin.png": 978,
	"./de.png": 979,
	"./de_pin.png": 980,
	"./discover.svg": 981,
	"./discover_active.svg": 311,
	"./discover_gray.svg": 310,
	"./entertainment.svg": 982,
	"./entertainment_pin.png": 983,
	"./exchange.svg": 984,
	"./exchange_pin.png": 985,
	"./ezgif.com-webp-to-png.png": 986,
	"./food.svg": 987,
	"./food_pin.png": 988,
	"./history.svg": 989,
	"./history_pin.png": 990,
	"./manekin_logo.png": 991,
	"./manekin_pin.png": 992,
	"./nature.svg": 993,
	"./nature_pin.png": 994,
	"./other.svg": 995,
	"./other_pin.png": 996,
	"./teatro cubano logo.webp": 997,
	"./treasure.svg": 998,
	"./treasure_1.png": 999,
	"./treasure_2.png": 1000,
	"./treasure_3.png": 1001,
	"./treasure_4.png": 1002,
	"./treasure_5.png": 1003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;